// Third party dependencies
import { Box, Gap, Heading, Toggle } from '@salecycle/ui-component-library';
import { useTranslation } from 'react-i18next';

export interface IProps {
  clientId: string;
  timestampRemoval: boolean;
  timestampFormat: boolean;
  compressFile: boolean;
  s3SubFolder: string;
  onToggle: (transformation: string, checked: boolean) => void;
}

export const FileExportTransformations = ({
  clientId,
  timestampRemoval,
  timestampFormat,
  compressFile,
  s3SubFolder,
  onToggle,
}: IProps) => {
  const { t } = useTranslation('fileExport');

  if (!clientId) {
    return null;
  }

  return (
    <>
      <Heading variation="h3">{t('config.create.transformations.heading')}</Heading>
      <Box stackItems={true}>
        <Toggle
          margin={false}
          ariaLabel={t('config.create.transformations.timestampRemoval.label')}
          label={t('config.create.transformations.timestampRemoval.label')}
          disabled={!s3SubFolder || timestampFormat}
          checked={timestampRemoval}
          onChange={checked => onToggle('timestampRemoval', checked)}
        />
        <Gap top={20} />
        <Toggle
          margin={false}
          ariaLabel={t('config.create.transformations.timestampFormat.label')}
          label={t('config.create.transformations.timestampFormat.label')}
          disabled={!s3SubFolder || timestampRemoval}
          checked={timestampFormat}
          onChange={checked => onToggle('timestampFormat', checked)}
        />
        <Gap top={20} />
        <Toggle
          margin={false}
          ariaLabel={t('config.create.transformations.compress.label')}
          label={t('config.create.transformations.compress.label')}
          disabled={!s3SubFolder}
          checked={compressFile}
          onChange={checked => onToggle('compressFile', checked)}
        />
      </Box>
    </>
  );
};
export default FileExportTransformations;
